export const LOUISIANA = 'LOUISIANA';
